export interface SuggestionRange {
  start: number
  end: number
  phrase: string
}

/** Các cụm gợi ý AI (nền vàng) — vị trí trong chuỗi plain text (blockSeparator \\n). */
export function getSuggestionRanges(content: string, phrases: string[]): SuggestionRange[] {
  const ranges: SuggestionRange[] = []
  for (const phrase of phrases) {
    let i = 0
    while (i < content.length) {
      const idx = content.indexOf(phrase, i)
      if (idx === -1) break
      ranges.push({ start: idx, end: idx + phrase.length, phrase })
      i = idx + phrase.length
    }
  }
  ranges.sort((a, b) => a.start - b.start)
  const merged: SuggestionRange[] = []
  for (const r of ranges) {
    if (merged.length && r.start < merged[merged.length - 1].end) continue
    merged.push(r)
  }
  return merged
}
